import React from 'react';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data,onDelete,onEdit}) => {
    const rows = [
        { label: 'Standard Production (%)', value: data.stdProduction },
        { label: 'Standard Mortality Rate (%)', value: data.stdMortalityRate },
        { label: 'Weight (gms)', value: data.weight },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={`Week ${data.week}`}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default Mobile;
